// Time durations in milliseconds
export const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
export const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
export const THIRTY_MINUTES_MS = 30 * 60 * 1000;
